import { Injectable } from '@angular/core';
import { ActiveTestQueuedStateService, DialogService, TabulatorService } from '@nrwl/common-lib';
import { WarningMessage } from '@nrwl/monitor-management';

@Injectable({
  providedIn: 'root'
})
export class MultipickerService {
  selectedSites = [];
  selectedDevices = [];
  TEST_LIMIT_COUNT = 2000;
  constructor(
    public activeTestQueuedStateService: ActiveTestQueuedStateService,
    private dialogService: DialogService,
    private tabulatorService: TabulatorService
  ) {}

  // eslint-disable-next-line
  getTestAssignedDatasource(data: any, deviceName: string): any {
    const dataSource = [];
    const testAssignedData = data?.queueStatus;
    for (const key in testAssignedData) {
      if (testAssignedData[key]?.total) {
        dataSource.push({
          type: key,
          used: testAssignedData[key]?.used,
          max: testAssignedData[key]?.total,
          className: this.tabulatorService.getTestTypeImage(key),
          maxCount: testAssignedData['maxCount'],
          overalUsed: testAssignedData['overall_total_used'],
          overalPercentage: Number.isNaN(testAssignedData['overall_percentage'])
            ? -1
            : testAssignedData['overall_percentage'],
          deviceName: deviceName,
          hasOveralPercentage: Number.isInteger(testAssignedData['overall_percentage'])
            ? 'block'
            : 'none',
          showProgressBar: Number.isInteger(testAssignedData['overall_percentage'])
            ? 'none'
            : 'block',
          hideView: true
        });
      }
    }
    return dataSource;
  }

  //eslint-disable-next-line
  getActiveTestQueuedStatus(deviceWithMonitors: any, id: string): any {
    return deviceWithMonitors.find(device => device.deviceData.id === id);
  }
  getWarningMessage(siteId: string, agentId: string, status: string, testType?: string): string {
    const message = this.activeTestQueuedStateService.warningMessage(agentId, testType);
    if (status === 'offline') {
      return 'Test will be queued/failed. Resources are offline';
    } else if (
      (message === WarningMessage.RESOURCE_AVAILABLE_WARNING_MESSAGE && status === 'online') ||
      !status
    ) {
      return null;
    } else {
      return message;
    }
  }
  showBulkTestLimitDialog(): void {
    const params = { action: 'bulk.selection' };
    const param = {
      id: params.action + '.activeTest',
      alternateMsg: `You can only create ${this.TEST_LIMIT_COUNT} items at a time. Please reduce your amount and try again.`,
      alternateTitle: 'Test count limit exceeded',
      callBackService: this
    };
    this.dialogService.showDialog('confirm', 'body', param);
  }
  showTestLimitDialog(warningMsg: string): void {
    const params = { action: 'start' };
    const param = {
      id: params.action + '.activeTest',
      alternateMsg: warningMsg,
      alternateTitle: 'Test count limit exceeded',
      callBackService: this
    };
    this.dialogService.showDialog('confirm', 'body', param);
  }
}
